<div class="splash-container" id="div_splash-container_7c8f6390">
  <div
    class="splash-container-images"
    id="div_splash-container-images_117bec48"
  >
    <div class="card flex justify-content-center gap-2" id="div_card_7193aadc">
      <p-confirmDialog
        [style]="{ width: '50vw' }"
        id="p-confirmDialog_de6cbd44"
      ></p-confirmDialog>
    </div>

    <div class="top-img" id="div_top-img_a7fa1ec3">
      <div class="shade" id="div_shade_69ac928e">
        <img
          loading="lazy"
          src="assets/img/railcar-search-transparent.svg"
          class="img-5"
        />
        <div class="header-info" id="div_header-info_1e01a827">
          <h2
            aria-label="Let's get started"
            title="Let's get started"
            class="text-uppercase"
            id="h2_text-uppercase_19becd62"
          >
            Let's get started
          </h2>
          <p id="p_7866898e">
            Select the product you’re shipping or the railcar type you need.
          </p>
        </div>
      </div>
    </div>
    <div class="main-container" id="div_main-container_27c5559b">
      <div
        class="splash-bottom-container"
        id="div_splash-bottom-container_7f20ee1d"
      >
        <div class="square-divider" id="div_square-divider_90a0f6f8">
          <div class="inside-box" id="div_inside-box_1ccb1cd7">
            <span class="p-float-label" id="span_p-float-label_f93bf868">
              <p-autoComplete
                id="stccs"
                [suggestions]="filteredSTCCs"
                [(ngModel)]="selectedProduct"
                [dropdown]="true"
                field="description_stcc"
                placeholder="Enter Product or STCC#"
                (completeMethod)="filterSTCC($event)"
                [forceSelection]="true"
                (onSelect)="selectStcc($event)"
                title="Product autocomplete"
                aria-label="Product or STCC# autocomplete"
              ></p-autoComplete>
              <label
                class="label-select"
                *ngIf="
                  selectedProduct !== undefined && selectedProduct !== null
                "
                aria-label="Product - STCC#"
                id="label_label-select_42f55183"
              >
              </label>
            </span>
            <button
              *ngIf="!boolDisplayProduct"
              class="btn btn-secondary btn-search"
              [disabled]="
                selectedProduct === undefined || selectedProduct === null
              "
              (click)="searchByStcc()"
              title="Search by STCC"
              aria-label="Search by STCC button"
              id="button_btn_a0a1a08e"
            >
              GO
            </button>
          </div>
          <div
            class="inside-box"
            *ngIf="boolDisplayProduct"
            id="div_inside-box_54ec8994"
          >
            <span class="p-float-label" id="span_p-float-label_a009f722">
              <input
                id="product-name"
                type="text"
                placeholder="Enter Product Name"
                required=""
                pInputText=""
                name="product_name"
                [(ngModel)]="productName"
                title="Product Name input"
                aria-label="Product Name input"
              />
              <label
                for="product-name"
                *ngIf="productName !== ''"
                aria-label="Product Name"
                id="label_6aa4e4cd"
              >
              </label>
            </span>
            <button
              class="btn btn-secondary btn-search"
              [disabled]="productName === ''"
              (click)="searchByStcc()"
              title="Search by Product Name"
              aria-label="Search by Product Name button"
              id="button_btn_cffae0d9"
            >
              GO
            </button>
          </div>

          <div class="category-cards" id="div_category-cards_d198bd16">
            <div class="box covered-hoppers" id="div_box_41bd97a2">
              <div class="shade" id="div_shade_acddd193">
                <h3
                  aria-label="Covered Hoppers"
                  title="Covered Hoppers"
                  id="h3_88b91297"
                >
                  Covered Hoppers
                </h3>
                <button
                  class="black-button"
                  (click)="searchByCarType(enumCarTypes.COVERED_HOPPER)"
                  pButton=""
                  type="button"
                  title="Search Covered Hoppers"
                  aria-label="Search Covered Hoppers button"
                  id="button_black-button_a6691327"
                >
                  Railcar Search
                </button>
              </div>
            </div>
            <div class="box pressure-tank" id="div_box_f98a2a9e">
              <div class="shade" id="div_shade_813e0a6c">
                <h3
                  aria-label="Pressure Tank Cars"
                  title="Pressure Tank Cars"
                  id="h3_65add5a9"
                >
                  Pressure Tank Cars
                </h3>
                <button
                  class="black-button"
                  (click)="searchByCarType(enumCarTypes.PRESSURE_TANK)"
                  pButton=""
                  type="button"
                  title="Search Pressure Tank Cars"
                  aria-label="Search Pressure Tank Cars button"
                  id="button_black-button_1d25c764"
                >
                  Railcar Search
                </button>
              </div>
            </div>
            <div class="box service-tank" id="div_box_441f459e">
              <div class="shade" id="div_shade_1a7fc537">
                <h3
                  aria-label="General Service Tank Cars"
                  title="General Service Tank Cars"
                  id="h3_46b64d0b"
                >
                  General Service Tank Cars
                </h3>
                <button
                  class="black-button"
                  (click)="searchByCarType(enumCarTypes.GENERAL_SERVICE)"
                  pButton=""
                  type="button"
                  title="Search General Service Tank Cars"
                  aria-label="Search General Service Tank Cars button"
                  id="button_black-button_af72dd9f"
                >
                  Railcar Search
                </button>
              </div>
            </div>
          </div>
          <div
            class="category-cards margin-top-card"
            id="div_category-cards_db878488"
          >
            <div class="box gondola" id="div_box_cc17f403">
              <div class="shade" id="div_shade_e79ac94a">
                <h3 aria-label="Gondola" title="Gondola" id="h3_3b3971dc">
                  Gondolas
                </h3>
                <button
                  class="black-button"
                  (click)="searchByCarType(enumCarTypes.GONDOLA)"
                  pButton=""
                  type="button"
                  title="Search Gondola Cars"
                  aria-label="Search Gondola Cars button"
                  id="button_black-button_3f4efbc4"
                >
                  Railcar Search
                </button>
              </div>
            </div>
            <div class="box open-hoppers" id="div_box_8f8c2b71">
              <div class="shade" id="div_shade_8271c389">
                <h3
                  aria-label="Open Hoppers"
                  title="Open Hoppers"
                  id="h3_b85b6a39"
                >
                  Open Hoppers
                </h3>
                <button
                  class="black-button"
                  (click)="searchByCarType(enumCarTypes.OPEN_HOPPER)"
                  pButton=""
                  type="button"
                  title="Search Open Hoppers"
                  aria-label="Search Open Hoppers button"
                  id="button_black-button_0a408edb"
                >
                  Railcar Search
                </button>
              </div>
            </div>
            <div class="box coming-soon" id="div_box_c18c5fe2">
              <div class="shade" id="div_shade_9c14c206">
                <h3
                  aria-label="Autoracks & Flat & Intermodal Coming Soon"
                  title="Autoracks & Flat & Intermodal Coming Soon"
                  id="h3_f8b163c8"
                >
                  Autoracks & Flat & Intermodal Coming Soon
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
